import React from "react";
import { NotificationCard } from "./NotificationCard";
import { NotificationUIProvider } from "./NotificationUIContext";

export function NotificationPage({ history, match }) {
  const notificationUIEvents = {
    newNotificationButtonClick: () => {
      history.push("/admin/notification/new");
    },
    openEditNotificationPage: id => {
      history.push(`/admin/notification/${id}/detail`);
    },
    openNotificationFilePage: id => {
      history.push(`/admin/notification/file/${id}`);
    }
  };

  return (
    <NotificationUIProvider notificationUIEvents={notificationUIEvents}>
      <NotificationCard history={history} match={match} />
    </NotificationUIProvider>
  );
}
